// import img from '../../Settings/img/settings.svg';

export const initialState = {
    isProcess: false,
    openPromoId: null,
    promo: [],
};